import { createAction, handleActions } from 'redux-actions';
import { formatCep, formatTelefone } from '../../commons/validation/validation';

// ACTION TYPES
const USER_LOGIN = `${process.env.PUBLIC_URL}/USER/LOGIN`;
const USER_LOGOUT = `${process.env.PUBLIC_URL}/USER/LOGOUT`;
const USER_FIND = `${process.env.PUBLIC_URL}/USER/FIND`;
const USER_PASSWORD_CHANGE = `${process.env.PUBLIC_URL}/USER/PASSWORD/CHANGE`;
const USER_UPDATE_STORE = `${process.env.PUBLIC_URL}/USER/UPDATE_STORE`;
const USER_REMOVE_STORE = `${process.env.PUBLIC_URL}/USER/REMOVE_STORE`;
const USER_EDIT = `${process.env.PUBLIC_URL}/USER/EDIT`;

export const types = {
	USER_LOGIN,
	USER_EDIT,
	USER_LOGOUT,
	USER_FIND,
	USER_PASSWORD_CHANGE,
	USER_UPDATE_STORE,
	USER_REMOVE_STORE
};

// ACTIONS
const loginUser = createAction(USER_LOGIN);
const forceLoginUser = createAction(USER_LOGIN, undefined, () => ({ force: true }));
const logoutUser = createAction(USER_LOGOUT);
const forceLogoutUser = createAction(USER_LOGOUT, undefined, () => ({ force: true }));
const changeUserPassword = createAction(USER_PASSWORD_CHANGE);
const findUser = createAction(USER_FIND);
const editUser = createAction(USER_EDIT);
const updateUserStore = createAction(USER_UPDATE_STORE);
const removeUserStore = createAction(USER_REMOVE_STORE);

export const actions = {
	loginUser,
	editUser,
	forceLoginUser,
	logoutUser,
	forceLogoutUser,
	changeUserPassword,
	findUser,
	updateUserStore,
	removeUserStore
};

// INITIAL STATE
const initialState = {};

// REDUCERS
const reducer = handleActions(
	{
		[USER_UPDATE_STORE]: (state, action) => ({
			...state,
			...action.payload
		}),
		[USER_REMOVE_STORE]: () => initialState
	},
	initialState
);

export default reducer;

// SELECTORS
const getUser = state => state.usuario;
const getDadosCadastrais = state => {
	let dadosCadastrais = getUser(state).dadosCadastrais;

	if (dadosCadastrais) {
		if (dadosCadastrais.cep === 0 || dadosCadastrais.cep === null) {
			dadosCadastrais.cep = '';
		} else {
			dadosCadastrais.cep = formatCep(dadosCadastrais.cep.toString());
		}

		if (dadosCadastrais.telefone !== null) {
			dadosCadastrais.telefone = formatTelefone(dadosCadastrais.telefone);
		}
	}

	return dadosCadastrais || {};
};
const isAuthenticated = state => Boolean(state.usuario.authenticated);
const getUserRoles = state => state.usuario.authorities || [];
const isUserInRole = (state, role) => getUserRoles(state).some(r => r === role);
const getAccessToken = state => state.usuario.token;

export const selectors = {
	getUser,
	getDadosCadastrais,
	isAuthenticated,
	getAccessToken,
	getUserRoles,
	isUserInRole
};
